import { RouteObject } from "react-router";
import Tilsynserklaering from "@/routes/tilsynserklaering/Tilsynserklaering";
import TilsynsErklaeringId, {
  tilsynsErklaeringIdLoader,
} from "@/routes/tilsynserklaering/[id]";
import { ROUTES } from "@/constants/routes";

export const tilsynRoutes: RouteObject[] = [
  {
    path: "/tilsynserklaering",
    element: <Tilsynserklaering />,
    children: [
      {
        id: ROUTES.tilsynForm.id,
        path: "/tilsynserklaering/:id",
        element: <TilsynsErklaeringId />,
        loader: tilsynsErklaeringIdLoader,
      },
    ],
  },
];
